import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAJEYD0uEr9x9GEsTZVv5-Aa9mpP-_TcQ4",
  authDomain: "ebikedubai.firebaseapp.com",
  projectId: "ebikedubai",
  storageBucket: "ebikedubai.firebasestorage.app",
  messagingSenderId: "834753226118",
  appId: "1:834753226118:web:430cd903a41f9e64997807",
  measurementId: "G-124SH8ZR9Q"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
